import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    cmsForm: {},
}

const insuranceSlice = createSlice({
    name: "insurance",
    initialState,
    reducers: {
        updateCmsForm: (state, action) => {
            state.cmsForm = action.payload
        },
    },
})

export const { updateCmsForm } = insuranceSlice.actions

export default insuranceSlice.reducer
